var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYahooIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2372 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    transform: "translate(2372 361)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.308,55.462,12.946,44.5,0,13.634H11.519l7.135,17.8,6.881-17.8H36.9L19.724,55.462ZM31.245,37.639a7.191,7.191,0,1,1,7.19,7.258A7.225,7.225,0,0,1,31.245,37.639Zm3.82-9.7L46.481,0H59.325L47.909,27.937Z",
    transform: "translate(2376 367)",
    fill: "#5f01d1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahooIcon);
export default __webpack_public_path__ + "static/media/yahoo-icon.b90fd8c3.svg";
export { ForwardRef as ReactComponent };